import { render } from "./Advertising.vue?vue&type=template&id=5084e824&scoped=true"
import script from "./Advertising.vue?vue&type=script&lang=js"
export * from "./Advertising.vue?vue&type=script&lang=js"

import "./Advertising.vue?vue&type=style&index=0&id=5084e824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5084e824"]])

export default __exports__